import { useEffect, useMemo, useState } from 'react'

export const useAllowExistingListItems = listItems => {
  const [isFirstListItemCreation, setIsFirstListItemCreation] = useState(false)

  const isListItemsExist = !!listItems.length
  const showListItemSelectionStep = isListItemsExist && !isFirstListItemCreation

  // separate state to prevent bug, when ListItemStep becomes visible after first list item creation
  useEffect(() => {
    if (!listItems.length) {
      setIsFirstListItemCreation(true)
    }
  }, [listItems.length, setIsFirstListItemCreation])

  return useMemo(() => ({ showListItemSelectionStep }), [showListItemSelectionStep])
}
